import React from 'react';

const VercelIcon = () => {
  return <img src='/skill-icons/vercel.png' alt='vercel-logo' />;
};

export default VercelIcon;
